import { Card } from "antd";
import PropTypes from "prop-types";
import { MdOutlineSearchOff } from "react-icons/md";

const EmptyState = ({ title, subtitle, icon: Icon = MdOutlineSearchOff }) => {
  return (
    <div className="no-products-empty-state">
      <Card className="no-products-card">
        <div className="no-products-content">
          <div className="no-products-icon-wrapper">
            <Icon className="no-products-icon" />
          </div>
          <h3 className="no-products-title">{title}</h3>
          {subtitle && <p className="no-products-description">{subtitle}</p>}
        </div>
      </Card>
    </div>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  icon: PropTypes.elementType,
};

export default EmptyState;
